import React from 'react';
import {Box, Grid} from '@mui/material'

const MobileSteps = ({
    position,
    steps

}) => {

    let content = []

    for(let i=0; i<steps; i++){
        const active = position === i
        content.push(
            <Grid item>
                <Box
                    sx={{
                        background:(theme)=> active ? theme.palette.primary.main : '#DFDFDF',
                        width:10,
                        height:10,
                        borderRadius:'50%',
                    }}
                />
            </Grid>
        )
    }

    return ( 
        <Box sx={{py:2}}> 
            <Grid container spacing={2} justifyContent='center'>
                {content}
            </Grid>
        </Box>
     );
}
 
export default MobileSteps;